module.exports = __webpack_public_path__ + "img/wujinmu4.ce6062ae.jpg";